export enum WebcastAttendeeType {
	AccountAdmin = 'AccountAdmin',
	Attendee = 'Attendee',
	Host = 'Host',
	Moderator = 'Moderator'
}
